import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function Legal() {
  return (
    <div className="legal-page">
      <Navbar />

      <section className="page-banner">
        <div className="hr-container">
          <span className="hr-eyebrow">Legal</span>
          <h1>Privacy &amp; Terms</h1>
          <p>How we protect your information and the terms of using our services.</p>
        </div>
      </section>

      <section className="hr-section">
        <div className="hr-container" style={{ maxWidth: "820px" }}>
          <div style={{ color: "var(--muted)", lineHeight: 1.8 }}>
            <h2
              style={{
                fontFamily: "var(--font-display)",
                color: "var(--navy)",
                fontSize: "1.5rem",
                margin: "0 0 12px",
              }}
            >
              Privacy Policy
            </h2>
            <p style={{ marginBottom: "26px" }}>
              Harmony Rise Homecare respects your privacy. Any personal
              information you share with us, such as your name, contact details
              and care needs, is used only to respond to your request and to
              provide our services. We do not sell your information to third
              parties.
            </p>

            <h2
              style={{
                fontFamily: "var(--font-display)",
                color: "var(--navy)",
                fontSize: "1.5rem",
                margin: "0 0 12px",
              }}
            >
              Terms of Service
            </h2>
            <p style={{ marginBottom: "26px" }}>
              Our nonmedical in-home care services are provided with care and
              professionalism. Service details, scheduling and care plans are
              agreed upon directly with each client and their family. Please
              contact us for the full terms that apply to your care agreement.
            </p>

            <p>
              Questions about these policies? Reach us at{" "}
              <a href="tel:2535230098" style={{ color: "var(--teal)" }}>
                253-523-0098
              </a>{" "}
              or{" "}
              <Link to="/contact" style={{ color: "var(--teal)" }}>
                send us a message
              </Link>
              .
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Legal;
